import { normalizeDate } from "./dateParser";
import { formatDateRange } from "./dateFormatter";

export const isDateRangeAvailable = (
  checkIn: Date,
  checkOut: Date,
  unavailableDates: Date[],
): boolean => {
  const requestedDates: Date[] = [];
  const current = new Date(checkIn);

  while (current < checkOut) {
    requestedDates.push(new Date(current));
    current.setDate(current.getDate() + 1);
  }

  const hasConflict = requestedDates.some((requestedDate) => {
    return unavailableDates.some((unavailableDate) => {
      const requested = normalizeDate(requestedDate);
      const unavailable = normalizeDate(unavailableDate);
      const isConflict = requested.getTime() === unavailable.getTime();

      return isConflict;
    });
  });

  const isAvailable = !hasConflict;

  return isAvailable;
};

export { formatDateRange };
